import { Add } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPuestos } from "../../../redux/actions/resolucion";
import { StyledPuestos } from "../../styled/Puestos";
import FormikAutocomplete from "../formik/FormikAutocomplete";
import NuevoPuestoFormContainer from "./nuevoPuesto/NuevoPuestoFormContainer";

const PuestosFormContainer = ({
  callBack,
  disabled,
  idDependenciaEmpleador,
  label = "Puesto",
  name = "idPuesto",
  add,
}) => {
  const dispatch = useDispatch();
  const { setFieldValue } = useFormikContext();
  const puestos = useSelector((state) => state.resolucion.puestos.data);
  const [openPuesto, setOpenPuesto] = useState(false);
  return (
    <>
      <StyledPuestos.Container>
        <StyledPuestos.InputContainer>
          <FormikAutocomplete
            name={name}
            label={label}
            fullWidth
            options={puestos}
            getOptions={() =>
              dispatch(getPuestos(idDependenciaEmpleador))
            }
            callBack={(e) => {
              if (callBack) callBack(e);
            }}
            disabled={disabled}
          />
        </StyledPuestos.InputContainer>
        {add ? (
          <Tooltip title="Agregar Puesto">
            <StyledPuestos.IconButton disabled={disabled} onClick={() => setOpenPuesto(true)}>
              <Add />
            </StyledPuestos.IconButton>
          </Tooltip>
        ) : null}
      </StyledPuestos.Container>
      <NuevoPuestoFormContainer
        open={openPuesto}
        handleClose={() => setOpenPuesto(false)}
        callback={(v) => {
          dispatch(getPuestos(idDependenciaEmpleador)).then((resPuestos) => {
            const puestos = resPuestos?.value?.data;
            setFieldValue(name, v?.value?.data);
            if (callBack && puestos) callBack(puestos.find(p => p.id === v?.value?.data));
          })
        }}
        idDependenciaEmpleador={idDependenciaEmpleador}
      />
    </>
  );
};

export default PuestosFormContainer;
